import React from 'react'
import { Container } from 'stories/Container'
import Logo from './Logo'
import { MdClear } from 'react-icons/md'
import { useNavigate } from 'react-router-dom'

export default function Navbar() {
  const navigate = useNavigate()

  return (
    <div className="bg-white h-24 w-full">
      <Container className="h-full flex justify-between items-center h-full">
        <Logo />
        <a onClick={() => navigate('/accounts')}>
          <MdClear size={24} className="text-ox-gray-700" />
        </a>
      </Container>
    </div>
  )
}
